const axios = require('axios');

var client = axios.create();
export default {
  load: (year) => client.get('/programmas/'+year+'.json',{
		transformResponse: [function (data) {
			return JSON.parse(data);
		}]
	})
}
